module.exports = __webpack_public_path__ + "static/media/600x600.a88db27e.png";